@if (
  (formGroup.controls.displayCustomerTenantPickerFlag?.value && allowedCustomerUuids?.length > 1) ||
  (formGroup.controls.displayLaboratoryTenantPickerFlag?.value && allowedLaboratoryUuids?.length > 1)
) {
  <form [formGroup]="formGroup" class="nav-group">
    <!-- User linked to several customer accounts-->
    @if (formGroup.controls.displayCustomerTenantPickerFlag?.value && allowedCustomerUuids?.length > 1) {
      <div class="tenant-selector-container fxf-auto-fill-r fxl-row fxla-space-between-center">
        <div (click)="customerTenantClickHandler()" class="fxf-auto-fill-r fxl-row">
          <mat-icon class="tenant-icon" svgIcon="svg_customer"></mat-icon>
          @if (allowedCustomerUuids?.length > 1) {
            <app-grouped-label-card
              [group]="formGroup.controls.customerTenant?.value?.name"
              [hat]="
                formGroup.controls.customerTenant?.value?.customerGroupFlag
                  ? 'Groupe de facturation'
                  : formGroup.controls.customerTenant?.value?.customerGroupName
              "
              [hatStyle]="formGroup.controls.customerTenant?.value?.customerGroupFlag ? 'primary' : 'primary-border'"
              [hatWidth]="'fixed'"
              [label]="formGroup.controls.customerTenant?.value?.laboratoryName"
              class="customer-card m-16"
            ></app-grouped-label-card>
          }
        </div>
        @if (allowedCustomerUuids?.length > 0) {
          <app-customer-tenant-picker
            #_customerTenantPickerComponent
            (customerTenantAddedEvent)="customerTenantPickerAddedHandler($event)"
            (pickerDialogAfterClosedEvent)="pickerDialogAfterClosedEventHandler()"
            class="m-12 picker-icon"
          ></app-customer-tenant-picker>
        }
      </div>
    }
    <!-- User linked to several laboratories accounts-->
    @if (formGroup.controls.displayLaboratoryTenantPickerFlag?.value && allowedLaboratoryUuids?.length > 1) {
      <div class="tenant-selector-container fxf-auto-fill-r fxl-row fxla-space-between-center">
        <div (click)="laboratoryTenantClickHandler()" class="fxf-auto-fill-r fxl-row">
          <mat-icon class="tenant-icon" svgIcon="svg_laboratory"></mat-icon>
          @if (allowedLaboratoryUuids?.length > 1) {
            <app-grouped-label-card
              [group]="'Laboratoire'"
              [label]="formGroup.controls.laboratoryTenant?.value?.name"
              class="customer-card m-16"
            ></app-grouped-label-card>
          }
        </div>
        @if (allowedLaboratoryUuids?.length > 0) {
          <app-laboratory-tenant-picker
            #_laboratoryTenantPickerComponent
            (laboratoryTenantAddedEvent)="laboratoryTenantPickerAddedHandler($event)"
            (pickerDialogAfterClosedEvent)="pickerDialogAfterClosedEventHandler()"
            class="m-12 picker-icon"
          ></app-laboratory-tenant-picker>
        }
        <mat-icon class="tenant-icon" svgIcon="svg_laboratory"></mat-icon>
      </div>
    }
  </form>
}
